import { StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';

import { TableHeaderProps } from './Table.types';
import TableCell from './TableCell';

// Create styles
const styles = StyleSheet.create({
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderColor: '#bfbfbf',
    marginTop: -0.1,
    backgroundColor: '#d3d3d3',
    textAlign: 'center',
  },
  tableCell: {
    fontSize: 11,
    fontWeight: 500,
    textAlign: 'center',
  },
  tableHeadCollection: { display: 'flex', flexDirection: 'column' },
});
export default function TableHeader({
  columns,
  colGroupModel,
}: TableHeaderProps) {
  return (
    <View style={[styles.tableHeadCollection]}>
      {Array.isArray(colGroupModel) && colGroupModel.length > 0 && (
        <View style={[styles.tableRow]}>
          {colGroupModel.map(({ groupId, headerName, children }, grpIndex) => {
            const colIndexes = children
              .map((de) =>
                columns.findIndex((each) => String(each.field) === String(de))
              )
              .filter((d) => d > -1);
            const minIndex = Math.min(...colIndexes);
            const maxIndex = Math.max(...colIndexes);
            return (
              <TableCell
                key={`${groupId}-${grpIndex}`}
                colSpan={Math.abs(maxIndex - minIndex) + 1}
                style={[styles.tableCell]}
              >
                {headerName}
              </TableCell>
            );
          })}
        </View>
      )}
      <View style={[styles.tableRow]}>
        {columns.map(({ field, colSpan = 1, headerName }) => (
          <TableCell key={field} colSpan={colSpan} style={[styles.tableCell]}>
            {headerName}
          </TableCell>
        ))}
      </View>
    </View>
  );
}
